import { Storage } from "utils/storage";

import { ControlHealthFilters } from "./types";

/**
 * Persists the applied filters so they survive a reload or a new session.
 * There is no shareable-link page state for Control Health yet, so the panel
 * keeps its own local storage entry.
 */
export const controlHealthFiltersStorage = new Storage<
    "localStorage",
    "controlHealth",
    "filters",
    ControlHealthFilters
>({
    type: "localStorage",
    namespace: "controlHealth",
    codecs: {
        encodeKey: (key) => key,
        encodeValue: (value) => JSON.stringify(value),
        decodeValue: (json) => JSON.parse(json) as ControlHealthFilters,
    },
});
